<section fxLayout="column" class="h-100">
    <section fxLayout="column" fxLayout.gt-sm="row" fxFlex class="h-100">
        <!-- Left Column - Inputs -->
        <section fxFlex.gt-sm="58" class="px-5 py-2">
            <mat-card fxLayout="column" class="sen-info-color-bg p-2 h-100">
                <!-- Selected Panel Info -->
                <div class="mb-3" *ngIf="sPanel">
                    <span>{{translate.getLng('SELECTED_MODUL')}}: {{sPanel.name}}</span>
                </div>

                <!-- Panel Count -->
                <div class="my-3">
                    <span>{{translate.getLng('MODCOUNT')}}: {{panelCount}}</span>
                </div>

                <!-- Cos Phi -->
                <div class="my-3" fxLayout="row" fxLayoutAlign="start center">
                    <span class="mr-3">{{translate.getLng('COS_PHI')}}:</span>
                    <div fxLayout="column" style="width: 100px;">
                        <input class="border-bottom text-right w-100"
                            [ngClass]="cosPhi.errors ? 'border-danger text-danger' : 'border-dark'"
                            [formControl]="cosPhi" step="0.01" min="0.01" max="1" type="number" matInput>
                        <mat-hint class="d-block sen-fs08 float-right" *ngIf="cosPhi.errors">
                            {{translate.getLng('MIN')}}: 0.01, {{translate.getLng('MAX')}}: 1
                        </mat-hint>
                    </div>
                </div>

                <!-- Sizing Section -->
                <div class="my-3" fxLayout="row" fxLayoutAlign="start center">
                    <span class="mr-3">{{translate.getLng('SIZING')}}:</span>
                    <div fxFlex>
                        <ngx-slider class="sen-fs12" [(value)]="sizingMinValue" [(highValue)]="sizingMaxValue"
                            [options]="sizingOptions">
                        </ngx-slider>
                    </div>
                </div>

                <!-- Inverter Selection -->
                <div class="my-3" fxLayout="row" fxLayoutAlign="start center">
                    <span class="mr-3">{{translate.getLng('INVERTER')}}:</span>
                    <mat-form-field fxFlex>
                        <mat-select #btnClose [formControl]="inverter" multiple>
                            <mat-option *ngFor="let i of SIService.inverterGroups" [value]="i.id">{{i.name}}</mat-option>
                            <span class="sen-colse-btn" (click)="btnClose.close()">
                                <mat-icon class="sen-fs18 mx-3" fxFlex="1 1 5%">clear</mat-icon>
                            </span>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Search Button -->
                <div class="my-3" fxLayout="column" fxLayoutAlign="center center">
                    <button (click)="searchInverters()" 
                            mat-raised-button 
                            style="width: 200px;">
                        {{translate.getLng('SEARCH')}}
                    </button>
                </div>
            </mat-card>
        </section>

        <!-- Right Column - Results Table -->
        <section fxFlex.gt-sm="42" class="sen-light-blue-bg h-100">
            <h2 class="px-3 pt-2">{{translate.getLng('INVERTERS')}}</h2>
            <table mat-table #varietyTable class="w-100 table" [dataSource]="dataSource">
                <ng-container matColumnDef="enum">
                    <th mat-header-cell *matHeaderCellDef> #</th>
                    <td mat-cell *matCellDef="let element">{{element.id}}</td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>{{translate.getLng('INVERTER_COMBINATION')}}</th>
                    <td mat-cell *matCellDef="let element">{{element.combi}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr class="sen-cursor-pointer" 
                    [ngClass]="{'selected': selectedInverterCombo?.id == row.id}" 
                    mat-row
                    (click)="setInveterCombo(row)" 
                    *matRowDef="let row; columns: displayedColumns;">
                </tr>
            </table>
        </section>
    </section>

    <!-- Navigation Buttons -->
    <div class="p-2" fxLayout="row" fxLayoutAlign="flex-end center">
        <button class="px-5 py-2" mat-raised-button color="primary" [routerLink]="[prevPath]">
            {{translate.getLng('PREV')}}
        </button>
        <button class="ml-3 px-5 py-2" mat-raised-button color="primary" (click)="onNextClick()">
            {{translate.getLng('NEXT')}}
        </button>
    </div>
</section>